import { Injectable } from '@angular/core';
import { Query, toBoolean } from '@datorama/akita';
import { AkitaAuthState, AkitaAuthStore } from './akita-auth.store';

/**
* @deprecated This class is deprecated and will be removed in future versions.
*/
@Injectable()
export class AkitaAuthQuery extends Query<AkitaAuthState> {

    isLoggedIn$ = this.select(state => toBoolean(state.user));
    user$ = this.select(state => state.user);

    constructor(protected store: AkitaAuthStore) {
        super(store);
    }

}